import Avatar from '@atlaskit/avatar';
import EditFilledIcon from '@atlaskit/icon/glyph/edit-filled';
import TrashIcon from '@atlaskit/icon/glyph/trash';
import { deleteVendorResponse } from '@atlassian/mpac-api-client';
import { breakpointValues, useResponsiveBreakpoint, UserGeneratedHTML } from '@atlassian/mpac-primitives';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect } from 'react';
import { useAsync } from 'react-async';
import { ActionsContainer, Container, Content, Header, LoadingButtonStyled, ResponseContent, VendorName } from './VendorResponse.styles';
import vendorDefaultLogo from './vendor-default-logo.png';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VendorResponse = _ref => {
  let {
    name,
    logo,
    response,
    vendorResponseEndpoint,
    mpacBaseUrl,
    handleDeletedVendorResponse,
    onEditVendorResponse,
    permissions,
    preloadVendorResponseEditor
  } = _ref;
  const {
    value: screenSize
  } = useResponsiveBreakpoint();
  const isMobile = screenSize <= breakpointValues.xs;
  const {
    isPending: isDeleteVendorResponseInProgress,
    isFulfilled: isDeleteVendorResponseSuccessful,
    isRejected: isDeleteVendorResponseRejected,
    error: deleteVendorResponseError,
    run: runDeleteVendorResponse
  } = useAsync({
    deferFn: deleteVendorResponse
  });
  useEffect(() => {
    if (isDeleteVendorResponseRejected) log.error('ReviewsTab', 'failed to delete vendor response', {
      error: deleteVendorResponseError
    });
  }, [isDeleteVendorResponseRejected]);
  useEffect(() => {
    if (isDeleteVendorResponseSuccessful) {
      handleDeletedVendorResponse();
    }
  }, [isDeleteVendorResponseSuccessful]);
  const onDeleteVendorResponse = e => {
    e.preventDefault();
    if (vendorResponseEndpoint) {
      const responseUrl = "".concat(mpacBaseUrl).concat(vendorResponseEndpoint);
      runDeleteVendorResponse(responseUrl);
    }
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(Avatar, {
        appearance: "square",
        src: logo !== null && logo !== void 0 ? logo : vendorDefaultLogo,
        size: "medium",
        name: "Vendor logo"
      }), isMobile && /*#__PURE__*/_jsx(VendorName, {
        children: name
      })]
    }), /*#__PURE__*/_jsxs(Content, {
      children: [!isMobile && /*#__PURE__*/_jsx(VendorName, {
        children: name
      }), /*#__PURE__*/_jsx(ResponseContent, {
        children: /*#__PURE__*/_jsx(UserGeneratedHTML, {
          dangerousHTML: response
        })
      }), permissions ? /*#__PURE__*/_jsxs(ActionsContainer, {
        children: [/*#__PURE__*/_jsx(LoadingButtonStyled, {
          onClick: onEditVendorResponse,
          onMouseEnter: preloadVendorResponseEditor,
          appearance: "subtle-link",
          iconBefore: /*#__PURE__*/_jsx(EditFilledIcon, {
            label: "Edit",
            size: "small"
          }),
          spacing: "none",
          "aria-label": "Edit Vendor Response",
          children: "Edit"
        }), "\u2022", /*#__PURE__*/_jsx(LoadingButtonStyled, {
          isLoading: isDeleteVendorResponseInProgress,
          onClick: onDeleteVendorResponse,
          appearance: "subtle-link",
          iconBefore: /*#__PURE__*/_jsx(TrashIcon, {
            label: "delete",
            size: "small"
          }),
          spacing: "none",
          "aria-label": "Delete Vendor Response",
          children: "Delete"
        })]
      }) : null]
    })]
  });
};